import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    status: 0
}

export const categoriesBulkEditSlice = createSlice({
    name: 'categoriesBulkEdit',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = categoriesBulkEditSlice.actions

export default categoriesBulkEditSlice.reducer